<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $t("alarm.start_date_filter") }}
        </label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:s',
            time_24hr: true,
          }"
          :value="startDatetime"
          @on-change="(selectedDates, val) => $emit('update:startDatetime', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $t("alarm.end_date_filter") }}
        </label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:s',
            time_24hr: true,
          }"
          :value="endDatetime"
          @on-change="(selectedDates, val) => $emit('update:endDatetime', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("pacom.type", 2) }}</label>
        <v-select
          :value="typeFilter"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="['ALARM','EVENT']"
          class="w-100"
          @input="(val) => $emit('update:typeFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("pacom.id", 2) }}</label>
        <b-form-input
          v-model="idFilter"
          class="d-inline-block mr-1"
          @input="(val) => $emit('update:idFilter', val)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
    flatPickr
  },
  props: {
    type: {
      default: null
    },
    typeFilter: {
      default: null
    },
    startDatetime: {
      type: String,
      default: null,
    },
    endDatetime: {
      type: String,
      default: null,
    },
    idFilter: {
      default: null
    }
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    }
  }
};
</script>
